import React from 'react'
import { Form, withFormik, FastField, ErrorMessage } from 'formik'
import Recaptcha from 'react-google-recaptcha'
import * as Yup from 'yup'
import { Button } from 'react-bootstrap'
import { recaptcha_key } from '../../config'
import styles from "./index.module.css"

const ContactForm = ({
    setFieldValue,
    isSubmitting,
    values,
    errors,
    touched,
}) => (
        <div id="contact" className="row no-gutters align-items-center justify-content-center my-5">
            <div className="col-12 text-center my-5">
                <div className={styles.pageTitle}>Contact Me</div>
            </div>
            <div className="col-10 col-sm-5 p-2 mb-2 text-center">
                <img alt="Contact me" src="/illustrations/contact_me.svg" className="img-fluid" style={{width: "80%"}}/>
            </div>
            <div className="col-10 col-sm-5 p-2">
                <Form
                    name="contact"
                    method="post"
                    data-netlify="true"
                    data-netlify-recaptcha="true"
                    data-netlify-honeypot="bot-field"
                >
                    <input type="hidden" name="form-name" value="contact" />
                    <div className={styles.inputField}>
                        <FastField
                            className={styles.formInput}
                            type="text"
                            name="name"
                            component="input"
                            aria-label="name"
                            placeholder="Full name*"
                            error={touched.name && errors.name}
                        />
                        <ErrorMessage className={styles.error} component={"span"} name="name" />
                    </div>
                    <div className={styles.inputField}>
                        <FastField
                            id="email"
                            aria-label="email"
                            component="input"
                            className={styles.formInput}
                            type="email"
                            name="email"
                            placeholder="Email*"
                            error={touched.email && errors.email}
                        />
                        <ErrorMessage className={styles.error} component={"span"} name="email" />
                    </div>
                    <div className={styles.inputField}>
                        <FastField
                            className={styles.formInput}
                            style={{resize: "none"}}
                            component="textarea"
                            aria-label="message"
                            id="message"
                            rows="4"
                            type="text"
                            name="message"
                            placeholder="Message*"
                            error={touched.message && errors.message}
                        />
                        <ErrorMessage className={styles.error} component={"span"} name="message" />
                    </div>
                    {values.name && values.email && values.message && (
                        <div className={styles.inputField}>
                            <FastField
                                component={Recaptcha}
                                sitekey={recaptcha_key}
                                name="recaptcha"
                                onChange={value => setFieldValue('recaptcha', value)}
                            />
                            <ErrorMessage className={styles.error} component={"span"} name="recaptcha" />
                        </div>
                    )}
                    {values.success && (
                        <div className={styles.inputField}>
                            <div>
                                <h4>
                                    Your message has been successfully sent, I will get back to you
                                    ASAP!
					</h4>
                            </div>
                        </div>
                    )}
                    <div>
                        <Button type="submit" disabled={isSubmitting} className="float-right" size="lg" block={true} variant="success">
                            Submit
			            </Button>
                    </div>
                </Form>
            </div>
        </div>
    )

export default withFormik({
    mapPropsToValues: () => ({
        name: '',
        email: '',
        message: '',
        recaptcha: '',
        success: false,
    }),
    validationSchema: () =>
        Yup.object().shape({
            name: Yup.string().required('Full name field is required'),
            email: Yup.string()
                .email('Invalid email')
                .required('Email field is required'),
            message: Yup.string().required('Message field is required'),
            recaptcha: Yup.string().required('Robots are not welcome yet!'),
        }),
    handleSubmit: async (
        { name, email, message, recaptcha },
        { setSubmitting, resetForm, setFieldValue }
    ) => {
        try {
            const encode = data => {
                return Object.keys(data)
                    .map(
                        key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`
                    )
                    .join('&')
            }
            await fetch('/?no-cache=1', {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: encode({
                    'form-name': 'contact',
                    name,
                    email,
                    message,
                    'g-recaptcha-response': recaptcha,
                }),
            })
            await setSubmitting(false)
            await setFieldValue('success', true)
            setTimeout(() => resetForm(), 2000)
        } catch (err) {
            setSubmitting(false)
            setFieldValue('success', false)
            alert('Something went wrong, please try again!') // eslint-disable-line
        }
    },
})(ContactForm)
